import React from 'react';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  } from 'recharts';

import CustomTooltip from './tooltip';
import './line.scss';



const Chart = (props) => {
  let height = 310;
  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  if (viewportWidth < 400) {
    height = 240;
  }

  if (!props.data) {
    return null;
  }

  const horizontalPoints = [];
  const data = props.data.slice(-6).map(item => {
    horizontalPoints.push(props.isTurnoverMeal ? item.turnoverMeal : item.turnoverSek);
    return {
      name: item.year,
      uv: props.isTurnoverMeal ? item.turnoverMeal : item.turnoverSek
    }
  });

  const factor = (Math.max(...horizontalPoints) * 2) / 4;
  const ticks = [0, factor, factor*2, factor*3];
  
  return (
    <ResponsiveContainer width="100%" height={height}>
        <LineChart data={data}
                   margin={{top: 0, right: 0, left: -30, bottom: 0}}>
            <CartesianGrid vertical={false} stroke="#d5dadd" />
            <XAxis dataKey="name" stroke="#d5dadd" tickLine={false} tick={{ fill: '#485465', fontSize: 10 }} />
            <YAxis stroke="#d5dadd" tickLine={false} tick={{ fill: '#485465', fontSize: 10 }} ticks={ticks} domain={[0, dataMax => (dataMax * 1.2)]} />
            <Tooltip content={<CustomTooltip unit={props.isTurnoverMeal ? '(antal/dag)' : '(KKR)'} />} />
            <Line type="monotone" dataKey="uv" stroke="#83b69c" strokeWidth="3" dot={{ stroke: '#83b69c', strokeWidth: 3, r: 5 }} />
        </LineChart>
    </ResponsiveContainer>
  );
};

export default Chart;